import React from "react";

class Ads extends React.Component {
  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  render() {
    return (
      <div>
        <ins
          class="adsbygoogle"
          style={{display:"block"}}
          data-ad-client="ca-pub-6480413874996580"
          data-ad-slot="3421149302"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
    );
  }
}

export default Ads;
